import * as React from 'react'
// libs
import { InjectedFormProps, reduxForm } from 'redux-form'
// components
import Grid from '@mui/material/Grid2'
import { ReduxInput, ReduxSelect } from 'components/FormElements/ReduxForm'
// constants
import { Forms } from 'constants/index'
// types
import { IField, IObjectEntityReviewQuestion } from 'types/graphql'
// views
import { Form, Label } from './views'

// review answer fields, matched to the object entity review questions by position
const QUESTION_FIELDS = ['goals', 'doWell', 'doBetter']

interface IIncomingProps {
  questions: IObjectEntityReviewQuestion[]
  picklists: IField[]
  isReadOnly?: boolean
}

const CreateReviewForm: React.FunctionComponent<InjectedFormProps & IIncomingProps> = ({
  questions,
  picklists,
  handleSubmit,
  isReadOnly
}) => {
  return (
    <Form onSubmit={handleSubmit}>
      {QUESTION_FIELDS.map((name, idx) => {
        const question = questions?.[idx]

        if (question && !question.active) {
          return null
        }

        return (
          <Grid key={name}>
            <Label>{question?.text || `Question ${idx + 1}. Please refresh the page to see the question.`}</Label>
            <ReduxInput disabled={isReadOnly} multiline name={name} />
          </Grid>
        )
      })}
      {picklists.map((item) => (
        <Grid key={item.id}>
          <Label>{item.label}</Label>
          <ReduxSelect
            isDisabled={isReadOnly || item.readonly}
            isMultiple={item.multiple}
            isClearable={!item.multiple}
            name={`picklists.${item.id}`}
            placeholder={'Select option'}
            options={(item.options || [])
              .filter((option) => option.active)
              .map((option) => ({ label: option.label, value: option.id }))}
          />
        </Grid>
      ))}
    </Form>
  )
}

export default reduxForm<any, any>({
  enableReinitialize: true,
  form: Forms.CREATE_REVIEW_FORM
})(CreateReviewForm)
